import { useAuthStore } from "@/stores/auth";
import { getAppMetadata } from "@/lib/jwt";

interface AppClaims {
  orgId: string;
  role: string;
  permissions: string[];
  isPlatformAdmin: boolean;
  /**
   * POS2-1057. Platform-level and org-agnostic, like isPlatformAdmin and
   * orthogonal to it — a labeller normally has no orgId at all, which is why
   * ProtectedRoute has to admit them explicitly.
   */
  isLabeller: boolean;
  siteIds: string[];
}

export function useClaims(): AppClaims {
  const session = useAuthStore((s) => s.session);
  const claims = session?.access_token
    ? getAppMetadata(session.access_token)
    : null;

  const scope = (claims?.scope as Record<string, string[]> | undefined) ?? {};

  return {
    orgId: (claims?.org_id as string) ?? "",
    role: (claims?.role as string) ?? "",
    permissions: (claims?.permissions as string[]) ?? [],
    isPlatformAdmin: (claims?.is_platform_admin as boolean) ?? false,
    isLabeller: (claims?.is_labeller as boolean) ?? false,
    siteIds: scope.site_ids ?? [],
  };
}

export function hasPermission(permissions: string[], code: string): boolean {
  return permissions.includes(code);
}

export function hasAnyPermission(permissions: string[], codes: string[]): boolean {
  return codes.some((code) => permissions.includes(code));
}
